<template>
  <!-- 公司简介 -->
  <div class="intro_wrap">
    <div class="text_container">
      <div class="text_container_inner">
        <div class="text_container_inner_title">
          {{introData.title}}
        </div>
        <div class="text_container_inner_content">
          <div class="content_box">
            <p>{{ introData.para_1 }}</p>
            <p>&nbsp;</p>
            <p>{{ introData.para_2 }}</p>
            <p>&nbsp;</p>
          </div>
          <div class="img_wrap">
            <div class="img_box"  v-for=" (imgItem) in introData.imgArr" :key="imgItem.id">
              <img :src="imgItem.imgUrl" :alt="imgItem.alt">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { aboutIntroData } from "@/data/aboutStaticData";
  export default {
    data() {
      return {
        introData: aboutIntroData
      }
    }
  }
</script>

<style scoped lang="scss">
.intro_wrap {
  width: 100%;
  height: auto;
  .text_container {
    width: 94%;
    max-width: 1280px;
    height: auto;
    margin: 90px auto ;
  }
}
.text_container_inner_title {
  width: auto;
  height: auto;
  line-height: normal;
  padding: 0 0 2% 0;
  margin: 0 auto;
  text-align: center;
  font-size: 24px;
  font-weight: normal;
  color: #333;
}
.text_container_inner_content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: auto;
  height: auto;
  .content_box {
    font-size: 16px;
    line-height: 2em;
    text-indent: 2em;
    letter-spacing: normal;
    color: rgba(102, 102, 102, 1);
  }
  .img_wrap {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 3px;
    width: 100%;
    height: auto;
    img {
      display: block;
      width: 100%;
      max-width: 100%;
      height: auto;
    }
  }
}
</style>
